import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.812.629a2.15 2.15 0 0 0-3.038 0L1.26 9.143a.5.5 0 0 0-.123.21l-1.12 4.042a.477.477 0 0 0 .588.588l4.042-1.12a.5.5 0 0 0 .21-.123l8.515-8.514a2.15 2.15 0 0 0 0-3.037zM2.3 9.453l6.968-6.968 2.248 2.247-6.97 6.969zm-.45.901 1.796 1.796-2.483.688zm10.847-6.803-.506.506L9.943 1.81l.507-.506a1.193 1.193 0 0 1 1.687 0l.56.56a1.195 1.195 0 0 1 0 1.687"
    }, null, -1)
  ]))]))
}
export default { render: render }